import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../types/type';
import { LoginDTO } from '../types/Entitys';
import { catchError, retry, throwError } from 'rxjs';
import { Utilerias } from '../helpers/Utilerias';

enum methods {
  Login = 'Login',
  GetCatalogoAppSettings = 'GetCatalogoAppSettings',
  GetCatalogoMenus = 'GetCatalogoMenus',
  DeleteTranControlSesionUsuario = 'DeleteTranControlSesionUsuario'
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  headers: HttpHeaders;
  URL: string;

  constructor(private http: HttpClient) {
    this.URL = environment.urlService;
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  login(params: LoginDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.Login}`, { login: params })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getSettings() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoAppSettings}`)
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getCatalogoMenus(idEmpleado: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoMenus}?idEmpleado=${idEmpleado}`, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteTranControlSesionUsuario(IdEmpleado: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.DeleteTranControlSesionUsuario}`, {
      idEmpleado: IdEmpleado,
      idTipoAplicacion: 1
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
